/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CallDealerModal_viewer$ref = any;
export type CallDealerModal_viewer = {
    readonly viewerUser?: {
        readonly profile: {
            readonly displayName: string | null;
        } | null;
    } | null;
    readonly primaryPhone?: {
        readonly countryCodeNumber: string | null;
        readonly formattedPhoneNumber: string | null;
        readonly isActive: boolean | null;
    } | null;
    readonly " $refType": CallDealerModal_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "CallDealerModal_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "viewerUser",
                        "name": "user",
                        "storageKey": null,
                        "args": (v0 /*: any*/),
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Profile",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "displayName",
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "preventEmailFallback",
                                                "value": true
                                            }
                                        ],
                                        "storageKey": "displayName(preventEmailFallback:true)"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "primaryPhone",
                        "storageKey": null,
                        "args": (v0 /*: any*/),
                        "concreteType": "Phone",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "countryCodeNumber",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "formattedPhoneNumber",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "isActive",
                                "name": "hasStatus",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "status",
                                        "value": "ACTIVE"
                                    }
                                ],
                                "storageKey": "hasStatus(status:\"ACTIVE\")"
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '2da1eed11b0f7b3657b9a53ca33226d8';
export default node;
